<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

import { useTableTeams } from '../../model/teams/table-teams.hook'
import TeamRowActions from './TeamRowActions.vue'

defineOptions({
  name: 'TableTeams',
})

const {
  teams,
  isLoading,
  hasTeams,
  meta,
  perPageOptions,
  formatDateTime,
  openTeam,
  setChangePage,
  setChangePerPage,
} = useTableTeams()
</script>

<template>
  <div class="table-teams">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :per-page-options="perPageOptions"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh class="text-center table-teams__id-cell">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              #
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Name
            </AppText>
          </AppTh>
          <AppTh class="text-center">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Members
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Created at
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Updated at
            </AppText>
          </AppTh>
          <AppTh class="table-teams__actions-cell" />
        </AppTr>
      </template>

      <template
        v-if="hasTeams"
        #body
      >
        <AppTr
          v-for="team in teams"
          :key="team.id"
        >
          <AppTd class="medium text-center table-teams__id-cell">
            <button
              type="button"
              class="table-teams__cell-link"
              :aria-label="`Open ${team.name}`"
              @click="openTeam(team)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ team.id }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <button
              type="button"
              class="table-teams__cell-link"
              :aria-label="`Open ${team.name}`"
              @click="openTeam(team)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ team.name }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium text-center">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ team.users_count ?? 0 }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-teams__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(team.created_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-teams__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(team.updated_at) }}
            </AppText>
          </AppTd>
          <AppTd class="zero-padding table-teams__actions-cell">
            <TeamRowActions :team="team" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableTeams.scss" />
